import { t } from "@impero-com/common/utils/i18n";
import { queryClient } from "@impero-com/common/utils/query_client";
import { emitNotification } from "@impero-com/ui";

import {
    getGetUsersUserIdSavedReportsQueryKey,
    usePatchUsersUserIdSavedReports,
} from "api/generated/users/users";

import { invalidateAssignmentCountQuery } from "./useAssignmentCountQuery";

export function useUpdateSavedReportRightsForUserMutation() {
    return usePatchUsersUserIdSavedReports({
        mutation: {
            onSuccess: async (_data, { userId }) => {
                emitNotification(
                    "success",
                    t("UserManagement_SavedReportsUpdated")
                );
                await Promise.all([
                    queryClient.invalidateQueries({
                        queryKey: getGetUsersUserIdSavedReportsQueryKey(userId),
                    }),
                    invalidateAssignmentCountQuery(userId.toString()),
                ]);
            },
        },
    });
}
